module.exports = __webpack_public_path__ + "img/ring_g_0_1_null@3x.03e18d9f.png";